export default __webpack_public_path__ + "static/media/bionca.b68b4e49.png";